import type { DashboardConfig } from '../config';
import { clusterBase } from '../clusterBase';

/*
 * Carrefour France "50 Ans — Part 3" (program cf08). Same client as the WC
 * report, separate report id. This campaign has NO sponsor brands: the payload
 * ships campaign.brands = [], empty games_by_brand and no coupons_by_brand, so
 * every brand widget disappears on data alone; segmentsLocation is omitted so
 * the per-brand table never renders. Unlike WC France, top_prizes IS shown —
 * prizes carry their own names (coupons, free products, lottery tickets)
 * rather than sponsor mappings.
 */
export const france50Config: DashboardConfig = {
  path: '/carrefour/france-50',
  reportId: 'carrefour-france-50-3',
  label: 'France · 50 Ans',
  endsOn: '2026-09-07', // 23 Jul → 7 Sep — archived from the day after
  apiBaseUrl: clusterBase('eu'),
  hide: {
    revenue: true,
    avgBasket: true,
    usersTraffic: true,
    itemsPerTx: true,
    gamesByBrand: true,
  },
  hasExport: true,
};
